import { Page } from '../components';
import { BatchRateForm } from '../forms';

export const BatchRate = () => (
  <Page render={() => <BatchRateForm />} />
);
